import {
  GameProductListItem,
  WishlistData,
  WishlistItemDataWithoutPrices,
} from '@/features/games/internal/types/wishlists';
import { removeEdgesAndNodes } from '@/shared/helpers/remove-edges-and-nodes';
import { ResultOf } from 'gql.tada';
import {
  PublicWishlistFragment,
  WishlistPaginatedItemsFragment,
  WishlistsFragment,
} from '@/features/games/internal/api/wishlists/graphql/wishlists.fragment';
import { accountRoutes } from '@/shared/constants/routes';

function convertWishlistItems(
  wishlistItems: ResultOf<typeof WishlistPaginatedItemsFragment>['items'],
): WishlistItemDataWithoutPrices[] {
  const listItems = removeEdgesAndNodes<GameProductListItem[]>(wishlistItems);
  if (!listItems) {
    return [];
  }
  return listItems
    .filter(
      (item): item is typeof item & { product: NonNullable<typeof item.product> } =>
        item.product !== null,
    )
    .map((item) => ({
      game: item.product,
      id: item.entityId,
    }));
}

export function convertWishlist(
  wishlist: ResultOf<typeof WishlistPaginatedItemsFragment>,
): WishlistData {
  const wishlistItems = convertWishlistItems(wishlist.items);
  return {
    id: wishlist.entityId,
    name: wishlist.name,
    shared: wishlist.isPublic,
    shareToken: wishlist.isPublic ? wishlist.token : undefined,
    href: `${accountRoutes.WISHLIST}/${wishlist.entityId}`,
    items: wishlistItems,
    itemsCount: wishlistItems.length,
  };
}

export const convertWishlists = (wishlists: ResultOf<typeof WishlistsFragment>): WishlistData[] => {
  // Some graphql library typing quirks causing type problems. TODO: Fix the typing https://gamigo.atlassian.net/browse/WTDEV-552
  // eslint-disable-next-line
  // @ts-ignore
  return removeEdgesAndNodes(wishlists).map((wishlist) => convertWishlist(wishlist));
};

export const convertSharedWishlist = (
  wishlist: ResultOf<typeof PublicWishlistFragment>,
): WishlistData => convertWishlist({ ...wishlist, isPublic: true });
